<template lang="pug">
.plan-empty
    .plan-empty__content
        SvIcon.plan-empty__icon(
            icon="mountains"
            :size="24"
        )

        span.plan-empty__text
            | Загрузите иконку

        .plan-empty__upload
            SvButton.plan-empty__button(
                view="bordered"
                text="Загрузить"
            )

            input.plan-empty__upload-input(
                type="file"
                @change="uploadImages"
            )
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import { Promise } from 'q';

export default {
  name: 'SolutionEmpty',

  components: {
    SvIcon,
    SvButton,
  },

  methods: {
    uploadImages(val) {
        const result = this.base64Image(val.target.files[0]);
        result.then(res => this.$emit('uploaded', res));
    },

    base64Image (image) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = () => {
                resolve(reader.result);
            };
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.plan-empty {
    border-radius: 6px;
    border: 2px dashed #E3E3ED;
    height: 490px;

    &__content {
        margin-top: 128px;
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__text {
        margin-top: 5px;
        font-size: 14px;
        line-height: 19px;
        color: #ADB2C0;
        text-align: center;
    }

    &__button {
        margin-top: 30px;
    }

    &__upload {
        position: relative;

        &-input {
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
}
</style>
